import React, {Component} from 'react';

import Button from '@material-ui/core/Button';
import MaterialDialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Dialog extends Component{

    constructor(props){
        super(props);
        this.state = {
            open: false
        };

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    open(){
        this.setState({
            open: true
        })
    }

    close(success){
        this.setState({
            open: false
        });
        if(success){
            this.props.confirm();
        }
    }

    render(){
        return (
            <MaterialDialog
                open={this.state.open}
                onClose={() => this.close(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {this.props.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.props.description}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.close(false)} color="primary">
                        {this.props.cancelText}
                    </Button>
                    <Button onClick={() => this.close(true)} color="primary">
                        {this.props.confirmText}
                    </Button>
                </DialogActions>
            </MaterialDialog>
        );
    }

}

export default Dialog;